import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
    Snackbar,
    SnackbarMessage,
    SnackbarVariant,
    SnackbarAction
} from 'app/components/core/Snackbar';
import { ErrorDetailsDialog } from 'app/components/composite/ErrorDetailsDialog';
import { ShowDetailsButton } from 'app/components/features/NotificationHub/ShowDetailsButton.jsx';
import { useToggleState } from 'app/lib/hooks';
import { DefaultErrorPropType } from 'app/lib/proptypes';

export const ConvertToModelFailedNotification = ({ id, onDismiss, error, name }) => {
    const { t } = useTranslation();
    const [isDialogOpen, toggleDialog] = useToggleState(false);
    const message = t('notifications:ConvertToModelFailed', { name });

    const handleDialogClose = useCallback(() => {
        toggleDialog();
        onDismiss(id);
    }, [id, toggleDialog, onDismiss]);

    return (
        <Snackbar id={id} onDismiss={onDismiss} variant={SnackbarVariant.ERROR}>
            <SnackbarMessage>{message}</SnackbarMessage>
            <SnackbarAction>
                <ShowDetailsButton onClick={toggleDialog} />
            </SnackbarAction>
            {isDialogOpen && (
                <ErrorDetailsDialog
                    message={error.message}
                    detail={error.stackTraceAsString}
                    onClose={handleDialogClose}
                />
            )}
        </Snackbar>
    );
};

ConvertToModelFailedNotification.propTypes = {
    id: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
    error: DefaultErrorPropType.isRequired,
    name: PropTypes.string
};
